import { withStyles } from "@material-ui/core/styles";
import EnhancedTableHead from "./EnhancedTableHead";
import styles from "./styles";

export default withStyles(styles)(EnhancedTableHead);
